import { useEffect, useState } from 'react';

import { strings } from '../strings';
import { getUserCoordinates } from '../utils/geolocation';
import type { Coordinates } from '../utils/geolocation';
import { MAP_CENTER } from '../utils/mapConfig';

const DEFAULT_COORDINATES: Coordinates = {
  latitude: MAP_CENTER.lat,
  longitude: MAP_CENTER.lng,
};

export const useUserCoordinates = () => {
  const [coordinates, setCoordinates] = useState<Coordinates>(DEFAULT_COORDINATES);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let isMounted = true;

    getUserCoordinates()
      .then(coords => {
        if (!isMounted) {
          return;
        }

        if (coords) {
          setCoordinates(coords);
        }
        setIsLoading(false);
      })
      .catch(caughtError => {
        if (!isMounted) {
          return;
        }

        console.error('Failed to get user coordinates', caughtError);
        setError(strings.unableToDetermineLocation);
        setIsLoading(false);
      });

    return () => {
      isMounted = false;
    };
  }, []);

  return { coordinates, isLoading, error };
};